/** Dark is the default. The saved choice shares the old app's `theme` key. */

export function currentTheme() {
  try {
    const saved = localStorage.getItem('theme');
    if (saved === 'light' || saved === 'dark') return saved;
  } catch {
    /* private mode */
  }
  return 'dark';
}

/** @param {'light'|'dark'|string} theme */
export function applyTheme(theme) {
  const next = theme === 'light' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', next);
  document.documentElement.style.colorScheme = next;
  return next;
}

export function initTheme() {
  return applyTheme(currentTheme());
}

export function toggleTheme() {
  const next = currentTheme() === 'dark' ? 'light' : 'dark';
  try {
    localStorage.setItem('theme', next);
  } catch {
    /* ignore */
  }
  return applyTheme(next);
}
